import { useEffect } from "react";

import { MenuListDto } from "services/menu/restModels";

import { useLocale } from "shared/hooks/useLocale";
import { useMenus } from "shared/hooks/useMenus";

export interface MenusListState {
    menus: MenuListDto[];
    locale: string;
    loading: boolean;
    error: boolean;
}

export const useMenusListState = (): MenusListState => {
    const locale = useLocale();
    const { menus, loading, error, refetch } = useMenus();

    /*
    * Модульный кеш useMenus заведён для селектов (диалог копирования позиции), а на этом
    * экране видны счётчики категорий и позиций — они меняются в редакторе меню. Поэтому при
    * входе список освежаем: до ответа показываем кешированный, а не пустой экран.
    * */
    useEffect(() => {
        refetch();
    }, [refetch]);

    return { menus, locale, loading, error };
};
